module.exports = __webpack_public_path__ + "img/icon_alimentary_record.20e254da.svg";